module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Left Arm Sofa_Sand.b36b5c18.png";